import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setError } from '../actions';
var PaddleOverlayButton = function PaddleOverlayButton(_ref) {
  var paddlePlanId = _ref.paddlePlanId,
    override = _ref.override,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$asButton = _ref.asButton,
    asButton = _ref$asButton === void 0 ? true : _ref$asButton,
    children = _ref.children,
    buttonClassName = _ref.buttonClassName;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    _useSelector$applicat = _useSelector.application,
    _useSelector$applicat2 = _useSelector$applicat.paddle,
    vendorId = _useSelector$applicat2.vendorId,
    scriptUrl = _useSelector$applicat2.scriptUrl,
    environment = _useSelector$applicat2.environment,
    siteLanguage = _useSelector$applicat.siteLanguage,
    _useSelector$user = _useSelector.user,
    email = _useSelector$user.email,
    identity = _useSelector$user.identity,
    _useSelector$curie$pl = _useSelector.curie.plan,
    planType = _useSelector$curie$pl.planType,
    status = _useSelector$curie$pl.status,
    grantingMechanism = _useSelector$curie$pl.grantingMechanism;
  if (!paddlePlanId || !vendorId) {
    return null;
  }
  var isPurchasing = !override;
  var hasActivePremiumPaddleOrAdminPlan = planType === 'premium' && status === 'active' && ['admin', 'paddle'].includes(grantingMechanism);
  var ref = useRef(null);
  var dispatch = useDispatch();

  // Once this launches we really should load paddle in index.ejs
  useEffect(function () {
    if (document.getElementById('paddleScript')) {
      return;
    }
    var scriptTag = document.createElement('script');
    scriptTag.id = 'paddleScript';
    scriptTag.async = true;
    document.body.appendChild(scriptTag);
    scriptTag.onload = function () {
      if (window.Paddle) {
        if (environment === 'sandbox') {
          window.Paddle.Environment.set('sandbox');
        }
        window.Paddle.Setup({
          vendor: vendorId
        });
      }
    };
    scriptTag.src = scriptUrl;
  }, []);
  var handleCheckoutClick = function handleCheckoutClick() {
    if (isPurchasing && hasActivePremiumPaddleOrAdminPlan) {
      dispatch(setError({
        title: 'duplicate plan',
        content: 'curie.duplicate-plan-description',
        primaryBtnText: 'got-it'
      }));
      return;
    }
    if (window.Paddle) {
      window.Paddle.Checkout.open({
        product: paddlePlanId,
        locale: siteLanguage,
        email: email,
        allowQuantity: false,
        disableLogout: true,
        customData: {
          user_identity: identity
        },
        closeCallback: function closeCallback() {
          return onClose(false);
        },
        successCallback: function successCallback() {
          return onClose(true);
        },
        override: override
      });
    }
  };
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: buttonClassName !== null && buttonClassName !== void 0 ? buttonClassName : "paddle-button ".concat(asButton ? 'btn btn-primary' : 'link-primary'),
    onClick: handleCheckoutClick,
    ref: ref
  }, children);
};
export default PaddleOverlayButton;